"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var WrenchLined = function WrenchLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.741 22A2.74 2.74 0 012.8 17.322l7.944-7.941a5.5 5.5 0 01-.252-1.623 5.7 5.7 0 017.7-5.393.522.522 0 01.333.378.528.528 0 01-.14.484L15.417 6.19l2.4 2.4 2.964-2.963a.527.527 0 01.484-.141.521.521 0 01.378.334A5.649 5.649 0 0122 7.758a5.76 5.76 0 01-5.753 5.752 5.5 5.5 0 01-1.624-.252L6.679 21.2a2.734 2.734 0 01-1.938.8zM16.247 3.052a4.712 4.712 0 00-4.708 4.706 4.626 4.626 0 00.3 1.587.523.523 0 01-.122.548l-8.176 8.169a1.7 1.7 0 102.4 2.4l8.172-8.169a.527.527 0 01.548-.122 4.627 4.627 0 001.588.3 4.713 4.713 0 004.707-4.706A4.179 4.179 0 0020.884 7l-2.7 2.7a.529.529 0 01-.741 0l-3.136-3.14a.525.525 0 010-.741l2.7-2.7a4.187 4.187 0 00-.76-.067z",
    fill: "currentColor"
  })));
};

var _default = WrenchLined;
exports["default"] = _default;